const hu = {
  common: {
    loading: "Betöltés...",
    error: "Hiba",
    save: "Mentés",
    cancel: "Mégse",
    delete: "Törlés",
    edit: "Szerkesztés",
    close: "Bezárás",
    search: "Keresés",
    noResults: "Nincs találat",
    confirm: "Megerősítés",
    run: "Futtatás",
    stop: "Leállítás",
    clear: "Törlés",
    refresh: "Frissítés",
    add: "Hozzáadás",
    all: "Mind",
    duplicate: "Másolás",
    expand: "Kibontás",
    collapse: "Összecsukás",
    copy: "másolat",
    running: "Fut...",
    stopping: "Leállítás...",
    clearing: "Törlés...",
    generating: "Generálás...",
    summarizing: "Összefoglalás...",
    noContent: "Nincs tartalom",
  },
  nav: {
    patients: "Kliensek",
    groupCaseload: "Praxis",
    groupSession: "Ülés",
    groupPatient: "Kliens",
    groupLibrary: "Könyvtár",
    theme: "Téma",
    language: "Nyelv",
    billing: "Számlázás",
    settings: "Beállítások",
    logout: "Kijelentkezés",
  },
  tabs: {
    session: "Ülés",
    prepare: "Felkészülés",
    canvas: "Eszköztár",
    assistant: "Asszisztens",
    journey: "Trendek",
    goals: "Házi feladatok",
    calendar: "Naptár",
    histories: "Előzmények",
    assessments: "Tesztek",
    cards: "Promptok",
    prompts: "Promptok",
    library: "Könyvtár",
  },
  library: {
    title: "Referenciakönyvtár",
    hint: "Tölts fel tanulmányokat, protokollokat és módszertani dokumentumokat (PDF, TXT, MD, max. 25 MB). Az asszisztens keres bennük, és cím + oldalszám szerint idéz belőlük.",
    uploadButton: "Dokumentum feltöltése",
    uploading: "Feltöltés…",
    loading: "Betöltés…",
    empty: "Még nincs dokumentum. Tölts fel egy tanulmányt, hogy az asszisztens idézhessen belőle.",
    pages: "oldal",
    statusProcessing: "Feldolgozás…",
    statusReady: "Kész",
    statusError: "Hiba",
    download: "Letöltés",
    delete: "Törlés",
    cancel: "Mégse",
    deleteConfirmTitle: "Dokumentum törlése?",
    deleteConfirmBody: "„{{title}}” és a hozzá tartozó keresési index véglegesen törlődik.",
    listFailed: "A könyvtár betöltése nem sikerült.",
    uploadFailed: "A feltöltés nem sikerült.",
    deleteFailed: "A törlés nem sikerült.",
    downloadFailed: "A letöltés nem sikerült.",
    stuckMessage: "A feldolgozás elakadt — töröld a dokumentumot és töltsd fel újra.",
  },
  session: {
    title: "Ülés jegyzetek",
    noSession: "Nincs kiválasztott ülés",
    selectPatient: "Válasszon klienst az ülések megtekintéséhez",
    timeline: "Idővonal",
    insights: "Meglátások",
    transcript: "Leirat",
    liveTranscript: "Élő leirat",
    summary: "Összefoglaló",
    tags: "Címkék",
    notes: "Jegyzetek",
    sessionDate: "Ülés dátuma",
    // Toolbar actions
    startRecording: "Felvétel indítása",
    stopRecording: "Felvétel leállítása",
    uploadVoice: "Hangfájl feltöltése",
    recordOnline: "Online",
    startOnlineRecording: "Online ülés rögzítése",
    onlineNoAudioTrack: "Nem lett hang megosztva. Válasszon böngészőfület (vagy Windowson teljes képernyőt), jelölje be a hangmegosztást, majd próbálja újra.",
    onlineMicDenied: "A mikrofon-hozzáférés el lett utasítva. Az online rögzítés nem indult el.",
    onlineStartFailed: "Az online rögzítést nem sikerült elindítani.",
    chunkUploadFailed: "A felvétel egy része nem töltődött fel. Ellenőrizze az internetkapcsolatot — a leiratból hiányozhat egy rész.",
    micDenied: "A mikrofon-hozzáférés el lett utasítva. A felvétel nem indult el.",
    micUnavailable: "Nem található használható mikrofon. A felvétel nem indult el.",
    recordStartFailed: "A felvételt nem sikerült elindítani.",
    recordingInterrupted: "A felvétel váratlanul leállt — kérjük, indítsa el újra.",
    recordingLabel: "Felvétel",
    recStripHint: "Felvétel folyamatban — kattintson az ülés panel megnyitásához",
    chunksUploaded_one: "{{count}} részlet feltöltve",
    chunksUploaded_other: "{{count}} részlet feltöltve",
    chunksLost_one: "{{count}} elveszett",
    chunksLost_other: "{{count}} elveszett",
    showTranscript: "Leirat megjelenítése",
    hideTranscript: "Leirat elrejtése",
    showNotes: "Jegyzet megjelenítése",
    clearTranscript: "Leirat törlése",
    saveSession: "Ülés mentése",
    deleteSession: "Ülés törlése",
    additionalContext: "További ülés kontextus",
    // Confirm dialogs
    clearTranscriptTitle: "Leirat törlése",
    clearTranscriptMessage: "Törli a leiratot? Ez törli a leiratot a szerveren ennél az ülésnél.",
    deleteSessionTitle: "Ülés törlése",
    deleteSessionMessage: "Törli ezt az ülést? Ez a művelet nem vonható vissza.",
    // Summary card
    generateSummary: "Összefoglaló generálása",
    sentToWorkspace: "Elküldve a munkaterületre",
    summaryEmptyState: "Rögzítsen egy ülést vagy írjon jegyzeteket ide.\nHasználja a csillag gombot az automatikus összefoglaláshoz.",
    // Transcript
    transcriptEmptyState: "Indítsa el a felvételt a beszélgetés rögzítéséhez.\nKattintson bármely üzenetre a fontos pillanatok rögzítéséhez.",
    pinQuote: "Idézet rögzítése",
    unpin: "Rögzítés feloldása",
    // Recording indicator
    recording: "FELV",
    idle: "INAKTÍV",
    // Replay
    replaySession: "Visszajátszás",
    exitReplay: "Visszajátszás vége",
    replaySpeed: "Lejátszási sebesség",
    record: "Felvétel",
    replayBtn: "Lejátszás",
    replay: "VISSZAJÁTSZÁS",
    // Upload processing
    uploadingFile: "Fájl feltöltése...",
    processingAudio: "Hang feldolgozása... az átirat hamarosan megjelenik",
    processingComplete: "Feldolgozás kész",
    uploadFailed: "Feltöltés sikertelen",
    processingFailed: "A hangfeldolgozás sikertelen",
    processingTimeout: "Az átírás nem készült el — úgy tűnik, a feldolgozás megszakadt.",
    transcriptConnectionLost: "Megszakadt a kapcsolat az átirat lekérése közben.",
    retry: "Újra",
    unsavedTitle: "Nem mentett módosítások",
    unsavedSwitchMessage: "Az ülésjegyzetekben nem mentett módosítások vannak. Elveti őket és vált?",
    discard: "Elvetés",
  },
  affektra: {
    title: "Affektra",
    runAgent: "Ügynök futtatása",
    stop: "Leállítás",
    clearOutputs: "Kimenetek törlése",
    emptyState: "Az Affektra javaslatokat és műveleteket fog ajánlani\naz ülés előrehaladtával.",
    execute: "Végrehajtás",
    runAgain: "Újrafuttatás",
    viewResult: "Eredmény megtekintése",
    // Card types
    insight: "Betekintés",
    newBoard: "Új tábla",
    newGoal: "Új cél",
    analysis: "Elemzés",
    // Loading state
    analyzing: "Ülés elemzése...",
    analyzingSubtext: "Az Affektra átnézi az átiratot és javaslatokat készít.",
    // Feedback
    helpful: "Hasznos",
    notHelpful: "Nem hasznos",
    // Confirm dialog
    clearOutputsTitle: "Kimenetek törlése",
    clearOutputsMessage: "Törli az összes Affektra kimenetet ennél az ülésnél?",
  },
  prepare: {
    title: "Felkészülés az Ülésre",
    subtitle: "Emlékeztetők generálása az utolsó ülések alapján: nyitott teendők, ígéretek, házi feladatok és visszatérő témák.",
    generate: "Felkészülés Generálása",
    regenerate: "Újragenerálás",
    lastSessions: "Utolsó {{count}} ülés",
    loading: "Felkészülés generálása...",
    empty: "Válasszon klienst és kattintson a Generálás gombra a felkészüléshez.",
    clientNotes: "Kliens jegyzetei",
    generationFailed: "A generálás sikertelen",
    generationTimeout: "A generálás túllépte az időkorlátot. Kérjük, próbálja újra.",
    noPreparation: "Nem készült felkészülés.",
  },
  prompts: {
    title: "Sablonok",
    new: "Új sablon",
    export: "Sablonok exportálása JSON-ba",
    searchPlaceholder: "Keresés név vagy leírás alapján...",
    noMatch: "Nincs a keresésnek megfelelő sablon.",
    loading: "Sablonok betöltése...",
    masterPrompts: "Fő sablonok",
    toolPrompts: "Eszköz sablonok",
    defaultDescription: "Rövid leírás.",
    defaultContent: "Írd ide a promptot. Az ülés átirata és jegyzetei automatikusan hozzáadódnak.",
    editor: {
      title: "Sablon Szerkesztése",
      name: "Sablon neve",
      kind: "Típus",
      description: "Leírás",
      descriptionPlaceholder: "Rövid leírás a csempén...",
      template: "Sablon Szövege",
      templateHint: "(a kiválasztott ülésen fut)",
      templatePlaceholder: "Írd ide a promptot...",
      result: "Eredmény",
      run: "Futtatás",
      save: "Mentés",
      useAsSummarizer: "Használat ülés-összefoglalóként",
      useAsSummarizerHint: "a Jegyzetek fül ezzel a sablonnal generál",
    },
    summarizerBadge: "Összefoglaló",
    kinds: {
      summarize: "összefoglaló",
      tool: "eszköz",
      trend: "trend",
      agent: "ügynök",
      prepare: "felkészülés",
    },
    extractor: {
      title: "Kinyerő beállítások",
      subtitle: "a trend-diagramok mérési eljárását határozza meg",
      source: "Adatforrás",
      sourceAuto: "automatikus (első futáskor egyszer besorolva)",
      outputType: "Kimenet",
      outputAuto: "automatikus",
      outputScore: "pontszám — egy szám ülésenként",
      outputTopics: "témák — 0–10 skálán pontozva",
      outputAirtime: "airtime — a téma részaránya az ülésből (beágyazás, LLM nélkül)",
      outputMarkers: "nyelvi markerek — kliens szóarányok 1000 szóra (kód, LLM nélkül)",
      ouraField: "Oura metrika",
      threshold: "Hasonlósági küszöb (0–1)",
      taxonomy: "Követett témák",
      taxonomyHint: "(soronként egy — üresen hagyva nyílt felfedezés)",
      taxonomyPlaceholder: "munkahelyi stressz\nalvás\ncsaládi konfliktus\nönkritika",
      anchors: "Skála-horgonyok",
      anchorsHint: "(mit jelent az egyes pontszám-szint — a horgonyzott skála konzisztensen pontoz)",
      anchorsPlaceholder: "0 = a téma nincs jelen\n5 = érdemben szóba kerül\n10 = domináns téma intenzív érzelmekkel",
      versionNote: "E mezők módosítása új kinyerő-verziót hoz létre: a korábbi ülések megtartják meglévő pontszámaikat, az új kinyerések már a frissített eljárással mérnek.",
    },
  },
  assistant: {
    cards: {
      calendar: "Naptár",
      noAppointments: "Ebben az időszakban nincs időpont.",
      unknownPatient: "Ismeretlen kliens",
      similar_sessions: "Hasonló ülések",
      similar_moments: "Hasonló pillanatok",
      noMatches: "Nincs találat.",
      chair_audio: "Sématerápiás szék hangfelvétel",
      audioExpires: "A hanglinkek egy óra után lejárnak.",
    },
    approval: {
      title: "Engedélyezi ezt a műveletet?",
      allow: "Engedélyezés",
      deny: "Elutasítás",
      unreadable: "A művelet részletei nem olvashatók.",
      chairCost: "A hangok generálása TTS-kreditet használ.",
      tools: {
        generate_chair_voices: "Szék hangfelvétel generálása",
      },
    },
    title: "Asszisztens",
    placeholder: "Kérjen formulációt, intervenciókat, házi feladat ötleteket...",
    send: "Küldés",
    thinking: "Gondolkodás...",
    error: "Hiba történt. Kérjük, próbálja újra.",
    newChat: "Új beszélgetés",
    newConversation: "Új beszélgetés",
    newConversationStarted: "Új beszélgetés indult. Kérdezzen bármit ebben a kontextusban.",
    deleteConversation: "Beszélgetés törlése",
    deleteConversationMessage: "Törli ezt a beszélgetést? Ez eltávolítja a szerverről.",
    showChatHistory: "Beszélgetési előzmények mutatása",
    showChatHistoryHint: "Beszélgetési előzmények mutatása",
    mainConversation: "Fő beszélgetés",
    conversationFallback: "Beszélgetés",
    welcome:
      "Az **Affektrával** beszélget. Kérjen formulációt, intervenciókat, házi feladat ötleteket vagy összefoglalókat.",
    working: "Dolgozom...",
    usingTool: "{{tool}} használata...",
    deleteFailed: "A beszélgetés törlése nem sikerült",
    connectionLost: "Megszakadt a kapcsolat — a válasz félbeszakadt. Kérjük, próbálja újra.",
    sendFailed: "Az üzenet küldése nem sikerült. Ellenőrizze a kapcsolatot, és próbálja újra.",
    interrupted: "(félbeszakadt)",
    errors: {
      internal: "Az asszisztensnél belső hiba történt. Kérjük, próbálja újra.",
      unavailable: "Az asszisztens átmenetileg nem elérhető. Kérjük, próbálja újra.",
      truncated: "A válasz a hosszkorlát miatt megszakadt.",
      empty: "Az asszisztens nem adott választ. Kérjük, próbálja újra.",
      title: "Nem sikerült címet generálni a beszélgetéshez.",
      unauthorized: "A munkamenet lejárt — töltse újra az oldalt és jelentkezzen be újra.",
      silentDeath: "Az asszisztens leállt válaszadás közben, befejezés nélkül. Kérjük, próbálja újra.",
    },
    effort: { quick: "Gyors", balanced: "Kiegyensúlyozott", deep: "Mély", hint: "Gondolkodás mélysége" },
    starters: {
      similarSessions: "Hasonló ülések",
      similarSessionsText: "Mutasd a hasonló üléseket ehhez.",
      similarSessionsSub: "Korábbi hasonló esetek lekérése",
      listSessions: "Összes ülés",
      listSessionsText: "Listázd az összes ülést ehhez a klienshez.",
      listSessionsSub: "Gyors áttekintés",
      schemaFit: "Séma értékelés illeszkedés?",
      schemaFitText: "Illeszkedik ez az ülés a séma értékeléshez?",
      schemaFitSub: "Leképezés és konzisztencia ellenőrzés",
      cbtPlan: "CBT terv",
      cbtPlanText: "Adj egy CBT tervet.",
      cbtPlanSub: "Célok → intervenciók → házi feladat",
    },
  },
  journey: {
    title: "Útiterv",
    description: "Vizualizálja a kliens fejlődését az idő múlásával. Adjon hozzá diagramokat témák, tünetek vagy témakörök követéséhez.",
  },
  digest: {
    eyebrow: "A hét olvasata",
    loading: "Az ülések olvasása…",
    error: "Az olvasat nem számítható ki",
    headlineBoth: "{{falling}} visszahúzódóban; {{rising}} viszi a terhet.",
    headlineRising: "{{rising}} egyre nagyobb teret kap az utóbbi üléseken.",
    headlineFalling: "{{falling}} visszahúzódóban az utóbbi üléseken.",
    headlineWarning: "Növekvő instabilitás: {{topic}} — változás közeledhet.",
    headlineGain: "Hirtelen javulás a {{instrument}} skálán — valami megmozdult.",
    headlineLoss: "Hirtelen visszaesés a {{instrument}} skálán — érdemes ránézni ezen a héten.",
    headlineStable: "Nincs megbízható elmozdulás ezen a héten — a kép stabil.",
    headlineNoData: "Még nincs elég adat — vegyél fel üléseket és futtass kinyerőket.",
    sessionsMeta: "{{count}} ülés · utoljára: {{when}}",
    today: "ma",
    daysAgo_one: "{{count}} napja",
    daysAgo_other: "{{count}} napja",
  },
  calendar: {
    title: "Naptár",
    today: "Ma",
    prevWeek: "Előző hét",
    nextWeek: "Következő hét",
    notifyClient: "E-mail küldése a kliensnek erről a változásról",
    invoicing: {
      label: "Az ülés lezajlott — számlázás",
      configure: "Számlázz.hu beállítása…",
      create: "Számla kiállítása",
      amount: "Összeg (Ft)",
      created: "Számla kiállítva: {{number}}",
      failed: "Számlázási hiba: {{msg}}",
      open: "Megnyitás a Számlázz.hu-n",
      storno: "Sztornó",
      stornoConfirm: "Sztornó megerősítése",
      stornoed: "sztornózva",
      stornoDone: "Sztornó kiállítva: {{number}}",
    },
    newAppointment: "Új időpont",
    editAppointment: "Időpont szerkesztése",
    cancelAppointment: "Időpont lemondása",
    patient: "Kliens",
    date: "Dátum",
    time: "Időpont",
    duration: "Időtartam (perc)",
    reminder: "Emlékeztető",
    notes: "Jegyzetek",
    scopeThis: "Csak ez az alkalom",
    scopeSeries: "Minden jövőbeli alkalom",
    leads: {
      0: "Kikapcsolva",
      60: "1 órával előtte",
      1440: "24 órával előtte",
      2880: "48 órával előtte",
    },
    recurrence: {
      label: "Ismétlődés",
      none: "Nem ismétlődik",
      weekly: "Hetente",
      biweekly: "Kéthetente",
      endBy: "Eddig tart (opcionális)",
    },
    gcal: {
      connect: "Google Naptár összekapcsolása",
      connected: "Google Naptár ✓",
      disconnect: "Google Naptár leválasztása",
      connectedToast: "Google Naptár összekapcsolva",
      errorToast: "A Google Naptár összekapcsolása sikertelen",
      failedCount: "{{count}} szinkronizálási hiba",
    },
    settings: {
      title: "Naptárbeállítások",
      workStart: "Munkanap kezdete",
      workEnd: "Munkanap vége",
      defaultDuration: "Alapértelmezett időtartam (perc)",
      defaultReminder: "Alapértelmezett emlékeztető (perccel előtte)",
      timezone: "Időzóna",
      invoicingTitle: "Számlázás — számlázz.hu",
      agentKey: "Számla Agent kulcs",
      agentKeySet: "mentve — hagyd üresen a megtartásához",
      itemName: "Számla tétel megnevezése",
      unitPrice: "Alapértelmezett ülésdíj (Ft, bruttó)",
      vatKey: "ÁFA",
      paymentMethod: "Fizetési mód",
      dueDays: "Fizetési határidő (nap)",
      eInvoice: "E-számla kiállítása (Agentből díjmentes)",
    },
    warnings: {
      overlap: "Ütközik egy másik időponttal",
      overlap_check_skipped_series: "Ütközésellenőrzés kihagyva a sorozatnál",
      email_skipped_no_address: "A kliensnek nincs e-mail-címe — nem ment értesítés",
      email_skipped_past: "Múltbeli időpont — nem ment értesítés",
      email_send_failed: "Az értesítő e-mail küldése sikertelen",
    },
    errors: {
      loadFailed: "A naptár betöltése sikertelen: {{msg}}",
      moveFailed: "Az időpont áthelyezése sikertelen: {{msg}}",
      saveFailed: "A mentés sikertelen: {{msg}}",
    },
  },
  goals: {
    title: "Házi feladatok",
    addGoal: "Cél Hozzáadása",
    filterPlaceholder: "Célok szűrése...",
    noGoals: "Még nincsenek célok. Kattints a „+ Cél Hozzáadása” gombra.",
    noMatch: "Nincs a szűrőnek megfelelő cél.",
    goalTitle: "Cél címe...",
    goalDesc: "Cél leírása...",
    noTasks: "Még nincsenek feladatok",
    addTask: "Feladat hozzáadása",
    removeGoal: "Cél törlése",
    editTask: "Feladat Szerkesztése",
    taskTitle: "Feladat címe...",
    taskDesc: "Rövid leírás...",
    duplicate: "Másolás",
    completedTasks: "Befejezett feladatok",
    completed: "Befejezett",
    noCompleted: "Még nincsenek befejezett feladatok. Húzzon egy feladatot a cél fejlécére az archiváláshoz.",
    goalDetails: "Cél részletei",
    loadingBoard: "Tábla betöltése...",
    dropToComplete: "Húzza ide a feladatokat a befejezéshez",
    clickToEdit: "Kattintson a szerkesztéshez; húzza a cél fejlécére az archiváláshoz",
    untitledTask: "Névtelen feladat",
    addDescription: "Adjon hozzá rövid leírást...",
    deleteCompletedTask: "Befejezett feladat törlése",
    defaultBoardTitle: "Házi feladat",
    defaultBoardDesc: "Terápiás célok és feladatok",
    saving: "Mentés…",
    saved: "Mentve",
    saveFailed: "A mentés nem sikerült.",
    retry: "Újra",
    conflictReloaded: "A táblát máshol módosították (kliens app vagy ügynök) — a legfrissebb verziót töltöttük be.",
    multipleBoards: "Ennek a kliensnek {{count}} táblája van — a legutóbbit mutatjuk.",
    confirmDeleteGoal: "Törlöd a(z) „{{title}}” célt és {{count}} feladatát? A teljesítési előzmények elvesznek.",
    completedThisWeek: "{{count}} ezen a héten",
    progress: "Előrehaladás",
    markComplete: "„{{title}}” megjelölése készként",
    restoreTask: "„{{title}}” visszaállítása aktívvá",
    assignee: "Felelős",
    assigneeUnset: "Nincs megadva",
    assigneeTherapist: "Terapeuta",
    assigneeClient: "Kliens (házi feladat)",
    dueDate: "Határidő",
    overdue: "Lejárt",
    byClient: "kliens által",
    byTherapist: "terapeuta által",
  },
  stories: {
    title: "Történetek",
    nowLast: "Utolsó ülés",
    nowFact: "{{theme}}: {{early}} moment/ülés → mára {{now}}",
    momentUnit: "moment",
    egyeb: "egyéb",
    quieterThemes: "+{{count}} csendesebb téma",
    echoes: "Visszhangok — hasonló momentek",
    openTranscript: "átirat →",
    coldStart:
      "Még kevés az anyag: {{sessions}}/{{minSessions}} ülés, {{moments}}/{{minMoments}} moment.",
    capped: "A térkép a legutóbbi {{sessions}} ülésből készült.",
    legendDot: "1 pont = 1 moment",
    legendDensity: "sűrűbb pontok = intenzívebb téma",
    legendEnvelope: "mező = ülésenkénti mennyiség",
    legendLatest: "utolsó ülés",
    legendEcho: "visszhang",
    legendContour: "szintvonal = téma-terület",
    legendOlder: "halvány pont = régebbi",
    legendPre: "szellem = idő-ablak előtti",
    fullStory: "teljes történet",
    play: "Lejátszás időben",
    windowStart: "Ablak kezdete",
    windowEnd: "Ablak vége",
    drift: "sodródás",
    loadError: "A történet-térkép betöltése nem sikerült",
  },
  settings: {
    autoNote: {
      title: "Automatikus haladási jegyzet",
      help: "Az ülés végén (weben vagy telefonon) az Affektra összefoglalja az ülést, és ebben a formátumban jegyzetvázlatot készít, amelyet Ön átnéz és aláír.",
      off: "Ki",
      notSet: "Még nincs beállítva: az ülések összefoglalója elkészül, de jegyzetvázlat csak formátumválasztás után.",
    },
    passkeys: {
      title: "Passkey-k",
      hint: "A passkey az ujjlenyomatoddal vagy az arcoddal igazol. Mentsd a Google Jelszókezelőbe, hogy az Affektra telefonos alkalmazásában is használhasd.",
      none: "Még nincs passkey-d.",
      unnamed: "Passkey",
      add: "Passkey hozzáadása",
      remove: "Eltávolítás",
      removeConfirm: "Eltávolítod a(z) \"{{name}}\" passkey-t? Ezután nem tudsz vele bejelentkezni.",
      removeFailed: "Nem sikerült eltávolítani a passkey-t.",
      loadFailed: "Nem sikerült betölteni a passkey-ket.",
    },
    toolbar: "Eszközsáv",
    toolbarHint: "Válassza ki, mely eszközök legyenek láthatók az oldalsávban. Legalább 2-nek láthatónak kell maradnia.",
    hideFromToolbar: "Elrejtés az eszközsávból",
    dangerZone: "Veszélyzóna",
    deleteAccount: "Fiókom törlése",
    deleteAccountWarning:
      "Véglegesen törli a fiókját és az ÖSSZES páciensadatot — minden ülést, átiratot, elemzést, felmérést és jegyzetet. Ez nem vonható vissza.",
    deleteAccountType: "A megerősítéshez írja be: DELETE",
    deleteAccountConfirmPrompt: "Ez véglegesen törli a teljes praxisát. Biztosan folytatja?",
    deleteAccountFailed: "A fiók törlése nem sikerült — próbálja újra.",
    deleting: "Törlés…",
    subscription: "Előfizetés",
    subPlanTrial: "Ingyenes próbaidőszak (teljes funkcionalitás)",
    subPlanAlap: "Alap — 20 ülés / hó",
    subPlanPro: "Pro — korlátlan",
    planNameAlap: "Alap",
    planNamePro: "Pro",
    subPlanNone: "Nincs aktív csomag",
    subTrialEnds: "Próbaidőszak vége",
    subRenews: "Megújul",
    subCancelAtEnd: "Az időszak végén megszűnik",
    subUpgradeAlap: "Alap előfizetés",
    subUpgradePro: "Pro előfizetés",
    subManage: "Számlázás kezelése",
    subCheckoutFailed: "A fizetés indítása nem sikerült — próbáld újra.",
    subAlreadySubscribed: "Már van aktív előfizetésed — frissítjük az adatokat.",
    subPortalFailed: "A számlázási portál megnyitása nem sikerült — próbáld újra.",
    subLoadFailed: "Az előfizetés betöltése nem sikerült — töltsd újra az oldalt.",
    subResumePrompt: "A(z) {{tier}} csomagot választottad — itt tudsz előfizetni.",
    billingSuccess: "Sikeres fizetés — az előfizetésed aktív.",
    billingCancelled: "A fizetés megszakadt — nem történt terhelés.",
    planRequired: "Ehhez a funkcióhoz aktív csomag kell — Számlázás a felhasználói menüben.",
    sessionLimit: "Elérted az Alap csomag havi üléskeretét.",
  },
  guide: {
    title: "Az Affektra használata",
    subtitle: "Válassza ki, mit szeretne csinálni, és kövesse a lépésről lépésre szóló útmutatót.",
    dropdownLabel: "Mit szeretne csinálni?",
    tip: "Tipp",
    whereToFind: "Hol találja",
    groupBefore: "Ülés Előtt",
    groupDuring: "Ülés Közben",
    groupAfter: "Ülés Után",
    // Core concept diagram
    conceptTitle: "Hogyan működik az Affektra",
    conceptSubtitle: "",
    conceptPrompts: "Promptok",
    conceptPromptsHint: "Terápia & jegyzet sablonok",
    conceptPromptsDesc: "Terápiákat leíró és jegyzetelést segítő sablonok",
    conceptSession: "Ülés Adatok",
    conceptSessionHint: "Átiratok és jegyzetek",
    conceptSessionDesc: "Rögzítsen üléseket az átiratok, összefoglalók és jegyzetek rögzítéséhez",
    conceptAI: "Affektra",
    conceptAIHint: "AI + tanul a visszajelzésből",
    conceptAIDesc: "Futtatja a promptjait az ülés adatokon elemzések generálásához",
    conceptResults: "Eredmények",
    conceptResultsHint: "Felismerések és műveletek",
    conceptResultsDesc: "Kapjon összefoglalókat, célokat, elemzéseket és javaslatokat",
    conceptKeyInsight: "Megjegyzés",
    conceptKeyInsightText: "A promptok, amiket létrehoz, meghatározzák, mit keres az Affektra. Nézze meg a Promptok fület a testreszabáshoz.",
    conceptStep1: "Rögzítsen üléseket az átiratok és jegyzetek rögzítéséhez",
    conceptStep2: "Készítsen promptokat, amelyek terápiákat írnak le és segítik a dokumentációt",
    conceptStep3: "Futtassa a promptokat üléseken felismerések, összefoglalók és célok generálásához",
  },
  charts: {
    loading: "Betöltés...",
    errorLoading: "Hiba az adatok betöltésekor",
    chartType: "Diagram típusa",
    extractors: "Kinyerők (több kiválasztható)",
    noExtractors: "Nincs elérhető kinyerő",
    runExtractor: "Futtassa a kinyerőt címkék generálásához",
    extract: "Kinyerés",
    confirmDelete: "Biztosan törölni szeretné: \"{{title}}\"?",
    correlation: "Korreláció",
    correlationTitle: "Téma-Hangulat korreláció",
    noCorrelationData: "Válassz egy téma-kinyerőt és egy pontszám-kinyerőt a korrelációk megjelenítéséhez.",
    topicShift: "Trend",
    noTopicShiftData: "Témaadatok szükségesek több ülésből a trendbecsléshez.",
    cooccurrence: "Együttes előfordulás",
    noCooccurrenceData: "Legalább 2 témát adó téma-kinyerő szükséges az együttes előforduláshoz.",
    volatility: "Instabilitás",
    noVolatilityData: "Legalább 3 ülés szükséges témaadatokkal az instabilitás méréséhez.",
    notEnoughSessions: "Megbízható statisztikához legalább {{need}} ülés kell — ennél a kliensnél eddig {{have}} használható.",
    compositionalExcluded: "Ez a kinyerő 100%-ra összegződő arányokat ad, amelyek között a korreláció konstrukciósan torzított. Használj 0–10 skálás (független témájú) kinyerőt helyette.",
    noAssessmentData: "Még nincs kérdőív-pontszám. Tölts fel teszteket és válassz kérdőív-kinyerőt.",
    noOuraData: "Nincs Oura adat ebben az időszakban — lehet, hogy a kliens nem kötötte össze a gyűrűjét.",
    noLeadlagData: "Válassz téma-kinyerőt; a lead-lag elemzéshez ülés-témák és napi Oura adatok kellenek.",
    noEarlywarningData: "A korai jelzéshez sorozatonként legalább 9 ülés kell (5 üléses mozgóablak).",
    noNetworkData: "Válassz legalább 2 témát adó téma-kinyerőt — a hálózathoz több idősor kell, 10+ üléssel.",
    networkNoEdges: "{{tested}} irányított kapcsolatot teszteltünk — egyik sem éli túl az FDR-kontrollt. Több üléssel élesedik a térkép.",
    sessions: "ülés",
    sessionsLabel: "Ülések",
    sessionsAll: "Összes ülés",
    renderLabel: "Megjelenítés",
    renderAuto: "Auto",
    renderRows: "Sorokra bontva",
    renderOverlay: "Egy panelen",
    hintBar: "Válassz 1 vagy több kinyerőt",
    hintCorrelation: "Válassz egy téma-kinyerőt + egy pontszám-kinyerőt (2)",
    hintTopicShift: "Válassz egy téma-kinyerőt (1)",
    hintCooccurrence: "Válassz egy téma-kinyerőt (1)",
    hintVolatility: "Válassz egy téma-kinyerőt (1)",
    hintAssessment: "Válassz egy kérdőívet",
    hintLeadlag: "Válassz egy téma-kinyerőt és egy Oura metrikát",
    hintDynamics: "Nincs teendő — az ülés-beágyazásokból számítjuk",
    hintEarlywarning: "Válassz téma- vagy pontszám-kinyerőket (9+ ülés kell)",
    hintNetwork: "Válassz több témát adó téma-kinyerőt (10+ ülés kell)",
    hintPhysio: "Nincs teendő — közvetlenül a napi Oura adatokat olvassa",
    descBar: "Halmozott oszlopdiagram, amely a témaeloszlást mutatja az idő folyamán. Minden oszlop egy ülést jelöl, az egyes életterületekre fordított idő százalékos arányával. Ezzel látható, mely területek uralják a beszélgetést, és hogyan változik az egyensúly az ülések során — például, hogy a munka témájú beszélgetés fokozatosan helyet ad-e a kapcsolati témáknak.",
    descCorrelation: "Spearman-rangkorreláció az egyes témák ülésről ülésre történő VÁLTOZÁSAI és a kliens pontszámának változásai között — trendszűrve, hogy két, a terápia alatt együtt sodródó érték ne mutasson hamis kapcsolatot. A p-értékek permutációs tesztből származnak, FDR-korrekcióval az összes pár között; a nem szignifikáns oszlopok szürkék. Legalább 8 közös ülés kell. Olvasata: 'amikor ez a téma nőtt két ülés között, a pontszám is nőtt/csökkent.'",
    descTopicShift: "Robusztus trend témánként: Theil-Sen meredekség (páronkénti meredekségek mediánja, pont/hét) Mann-Kendall szignifikancia-teszttel, FDR-korrekcióval a témák között. A pozitív oszlopok erősödnek a terápia alatt, a negatívak halványulnak; a szürke oszlopok statisztikailag nem különböznek a trend-nélküliségtől. Kérdés, amire válaszol: 'Mi az, ami megbízhatóan nő vagy csökken a terápia során?'",
    descCooccurrence: "Hőtérkép a témapárok közötti trendszűrt Spearman-korrelációkról az ülések során, permutációs p-értékekkel és FDR-kontrollal — az itt látható 'klaszter' tehát statisztikailag védhető, nem a sok pár tesztelésének műterméke. A nem szignifikáns cellák halványak, az érték zárójelben. Páronként legalább 8 ülés kell.",
    descVolatility: "Ülésről ülésre mért instabilitás témánként, RMSSD-vel mérve (egymást követő különbségek négyzetes középértéke) — az affektuskutatás standard instabilitás-mutatója. A sima szórással ellentétben az egyenletes javuló trend NEM számít instabilitásnak; csak a valódi ide-oda ingadozás. A magas oszlopok azt jelzik, hogy a téma egymást követő ülések között felugrik és eltűnik.",
    descAssessment: "Validált kérdőív-pontszámok (pl. PHQ-9, GAD-7) az idő függvényében, klinikai határérték-sávokkal, így a megbízható változás egy pillantásra látszik.",
    descLeadlag: "Keresztkorreláció egy ülés-téma és a napi Oura élettani adatok között ±N napos eltolással — a test vezeti az elmét, vagy követi?",
    descDynamics: "Beágyazásokból számított ülés-dinamika: újdonság (mennyire mozdul el az ülés az előzőhöz képest) és téma-entrópia (fókuszált vagy szétszórt ülések). LLM-hívás nélkül számítva.",
    descEarlywarning: "Kritikus lelassulás detektor a dinamikus rendszerek kutatásából: az emelkedő lag-1 autokorreláció ÉS emelkedő variancia egy 5 üléses mozgóablakban gyakran megelőzi a hirtelen klinikai váltást — áttörést vagy visszaesést. Minden idősor egy pont; a jobb felső negyed (mindkét trend emelkedik, Mann-Kendall p<.10) a destabilizációs zóna, pirossal jelölve. Figyelmeztető jelzés, nem diagnózis.",
    descNetwork: "Időbeli téma-hálózat: az A-ból B-be mutató nyíl azt jelenti, hogy A változása ezen az ülésen előrejelzi B változását a következőn (késleltetett Spearman, trendszűrve, FDR-kontrollal — csak a túlélő élek jelennek meg). Zöld = felfelé hajt, piros = lefelé. A csomópont mérete a kimenő erősség: a legnagyobb csomópont a legjobb beavatkozási célpont — az a téma, amelyik a többit mozgatja.",
    descPhysio: "Napi Oura-adatsorok (alvás, felkészültség, HRV, pulzus) — nyers napi pontfelhő plusz 7 napos mozgóátlag mutatónként, az ülések dátumai halvány függőleges vonalként jelölve. Az egyes sorok trendje (Theil-Sen meredekség évente, Mann-Kendall p) ISO-heti átlagokon számítva, hogy a napi autokorreláció ne torzítsa túl a szignifikanciát.",
    typeBar: "Idővonal",
    typeAssessment: "Kérdőívek",
    typeLeadlag: "Lead-lag (Oura)",
    typeDynamics: "Ülés-dinamika",
    typeEarlywarning: "Korai jelzés",
    typeNetwork: "Téma-hálózat",
    typePhysio: "Testi trajektória",
    addChart: "Diagram hozzáadása",
    filterPlaceholder: "Diagramok szűrése...",
    loadingCharts: "Diagramok betöltése...",
    createNew: "Új diagram létrehozása",
    titleLabel: "Cím",
    descriptionLabel: "Leírás",
    descriptionPlaceholder: "Mit mér ez a diagram?",
    extractorsLabel: "Kinyerők",
    lastN: "Utolsó {{count}}",
    creating: "Létrehozás...",
    create: "Diagram létrehozása",
    createFailed: "A diagram létrehozása sikertelen: {{message}}",
    updateFailed: "A diagram frissítése sikertelen: {{message}}",
    deleteFailed: "A diagram törlése sikertelen: {{message}}",
  },
  errors: {
    noAuthToken: "Nincs hitelesítési token - a felhasználó nincs bejelentkezve.",
    noMediaStream: "Nincs média stream",
    getUserMediaNotSupported: "A getUserMedia nem támogatott ebben a böngészőben.",
    missingSessionId: "Hiányzó ülés azonosító",
    failedToCreateSession: "Nem sikerült létrehozni az ülést a felvétel előtt.",
  },
  clientSelector: {
    label: "Kliens:",
    loading: "Betöltés\u2026",
    failedToLoad: "Nem sikerült betölteni",
    noClients: "Nincsenek kliensek",
    error: "Nem sikerült betölteni a klienseket",
  },
  sessionSelector: {
    label: "Ülés:",
    selectPatientFirst: "Először válasszon klienst",
    currentSession: "Aktuális ülés",
    errorLoading: "Hiba az ülések betöltésekor",
    failedToLoad: "Nem sikerült betölteni az üléseket",
  },
  patients: {
    title: "Kliensek",
    searchPlaceholder: "Keresés név, email vagy telefon alapján...",
    reload: "Újratöltés",
    new: "Új",
    name: "Név",
    email: "Email",
    phone: "Telefon",
    dob: "Születési dátum",
    actions: "Műveletek",
    noMatch: "Nincs a keresésnek megfelelő kliens.",
    editPatient: "Kliens szerkesztése",
    newPatient: "Új kliens",
    notes: "Megjegyzések",
    dobPlaceholder: "ÉÉÉÉ-HH-NN vagy szabad szöveg",
    saving: "Mentés...",
    saveChanges: "Változtatások mentése",
    billingTitle: "Számlázási adatok",
    billingName: "Számlázási név (ha eltér)",
    billingZip: "Irányítószám",
    billingCity: "Település",
    billingAddress: "Utca, házszám",
    billingTaxNumber: "Adószám (cégeknek)",
    deletePatient: "Kliens törlése",
    confirmDelete: "Törli a következő klienst: {{name}}? Ez nem vonható vissza.",
    creating: "Létrehozás...",
    create: "Létrehozás",
    load: "Betöltés",
    connectorWipTag: "wip",
    connectorWipTooltip: "Készülőben — még nem csatlakoztatható",
    connectors: "Csatlakozók",
    inviteToApp: "Meghívás az alkalmazásba",
    inviteSending: "Küldés...",
    inviteSent: "Meghívó elküldve",
    inviteActive: "Alkalmazás aktív",
    inviteDisabled: "Alkalmazás letiltva",
    revokeAccess: "Visszavonás",
    inviteSuccess: "Meghívó elküldve: {{email}}",
    inviteError: "Nem sikerült elküldeni a meghívót",
    revokeSuccess: "Alkalmazás hozzáférés visszavonva",
    revokeError: "Nem sikerült visszavonni a hozzáférést",
    noEmail: "Először adjon hozzá egy e-mail címet",
  },
  consent: {
    badgeFull: "Hozzájárulás rendben",
    badgePartial: "Részleges hozzájárulás",
    badgeNone: "Nincs hozzájárulás",
    statusUnavailable: "A hozzájárulási állapot nem érhető el",
    loading: "Betöltés...",
    dialogTitle: "Adatkezelési hozzájárulás",
    policyVersion: "Szabályzat verziója: {{version}}",
    close: "Bezárás",
    thePatient: "a kliens",
    purposeRecording: "Ülések rögzítése",
    purposeRecordingDesc: "A terápiás ülések hangfelvétele és leirata",
    purposeAiAnalysis: "MI-elemzés",
    purposeAiAnalysisDesc: "MI által készített összefoglalók, címkék, trendek és hasonló történetek",
    purposeWearables: "Viselhető eszköz adatai",
    purposeWearablesDesc: "Oura Ring egészségadatok (alvás, készenlét, HRV)",
    statusGranted: "Megadva",
    statusNotGranted: "Nincs megadva",
    attestGrant: "Hozzájárulás rögzítése",
    attestRevoke: "Visszavonás rögzítése",
    confirmGrantTitle: "Rögzítés megerősítése",
    confirmRevokeTitle: "Visszavonás megerősítése",
    confirmGrantText:
      "Ön azt rögzíti, hogy {{name}} hozzájárult a következőhöz: {{purpose}}. Ez végleges bejegyzést hoz létre a hozzájárulási naplóban.",
    confirmRevokeText:
      "Ön azt rögzíti, hogy {{name}} visszavonta a hozzájárulását ehhez: {{purpose}}. Az erre a célra irányuló további adatkezelés azonnal leáll; a meglévő adatok törlési kérelemig megmaradnak.",
    confirmCheckboxGrant:
      "Megerősítem, hogy a kliens kifejezett hozzájárulását adta (papíron vagy szóban), és az aláírt nyilatkozatot megőrzöm.",
    confirmCheckboxRevoke:
      "Megerősítem, hogy a kliens visszavonta ezt a hozzájárulását (papíron vagy szóban).",
    confirmSubmit: "Megerősítés",
    confirmSubmitting: "Mentés...",
    cancel: "Mégse",
    attestSuccess: "Hozzájárulási bejegyzés elmentve",
    attestError: "Nem sikerült elmenteni a hozzájárulási bejegyzést",
    loadError: "Nem sikerült betölteni a hozzájárulási állapotot",
    retry: "Újra",
    historyTitle: "Előzmények",
    historyEmpty: "Még nincs rögzített hozzájárulási esemény.",
    channelMobileApp: "Kliensalkalmazás",
    channelDashboard: "Terapeuta általi rögzítés",
    actionGranted: "megadva",
    actionRevoked: "visszavonva",
    recordingWarning: "Nincs rögzítési hozzájárulás",
    recordingWarningTooltip:
      "Ehhez a klienshez nincs rögzített hozzájárulás az ülések felvételéhez. A felvétel egyelőre nincs letiltva, de a hozzájárulást az ülés előtt rögzíteni kell.",
  },
  oura: {
    connect: "Oura Ring csatlakoztatása",
    connected: "Oura csatlakoztatva",
    disconnect: "Leválasztás",
    disconnected: "Oura Ring leválasztva.",
    connectError: "Nem sikerült meghívót létrehozni",
    disconnectError: "Nem sikerült leválasztani",
    inviteTitle: "Oura meghívó link megosztása",
    inviteHint: "Küldje el ezt a linket a kliensének. Ő engedélyezi az Oura Ring adatok megosztását.",
    copyLink: "Link másolása",
    copied: "Másolva!",
    extractorName: "Oura Ring",
    consentTitle: "Oura Ring csatlakoztatása",
    consentBody: "Terapeutája meghívta Önt az Oura Ring adatai (alvás, készenlét, HRV) megosztására.",
    connectButton: "Csatlakozás Ourával",
    successTitle: "Oura Ring csatlakoztatva",
    successBody: "Adatai mostantól megosztásra kerülnek terapeutájával. Bezárhatja ezt az oldalt.",
    errorTitle: "Csatlakozás sikertelen",
    sleepScore: "Alvás pontszám",
    readiness: "Készenlét",
    hrvBalance: "HRV egyensúly",
  },
  notesReview: {
    title: "Átnézendő jegyzetek",
    loadFailed: "Nem sikerült betölteni a jegyzetvázlatokat",
    unknownPatient: "Ismeretlen kliens",
  },
  login: {
    title: "Affektra",
    subtitle: "Jelentkezzen be fiókjába",
    email: "Email",
    emailPlaceholder: "email@pelda.hu",
    password: "Jelszó",
    passwordPlaceholder: "Adja meg jelszavát",
    rememberDevice: "Eszköz megjegyzése 30 napig",
    signingIn: "Bejelentkezés...",
    signIn: "Bejelentkezés",
    forgotPassword: "Elfelejtett jelszó?",
    forgotPasswordSubtitle: "Adja meg az email címét és küldünk egy visszaállító kódot.",
    sendCode: "Kód küldése",
    sendingCode: "Kód küldése...",
    resetCode: "Ellenőrző kód",
    resetCodePlaceholder: "Adja meg a 6 jegyű kódot",
    newPassword: "Új jelszó",
    newPasswordPlaceholder: "Adja meg az új jelszavát",
    resetPassword: "Jelszó visszaállítása",
    resettingPassword: "Jelszó visszaállítása...",
    resetSuccess: "Jelszó sikeresen visszaállítva",
    resetSuccessSubtitle: "Most már bejelentkezhet az új jelszavával.",
    backToLogin: "Vissza a bejelentkezéshez",
    emailCodeTitle: "Nézze meg az e-mailjeit",
    emailCodeSubtitle: "6 jegyű bejelentkezési kódot küldtünk ide: {{email}}. Utána beállít egy passkey-t, így legközelebb elég az ujjlenyomata vagy az arca.",
    emailCodeVerify: "Ellenőrzés",
  },
  experiential: {
    suggest: {
      title: "Kitöltés ülésekből",
      hint: "Válasszon legfeljebb {{n}} ülést — az AI javasolja az aktív módokat és azt, amit mondanak, a kliens szavaival.",
      run: "Székek javaslása",
      running: "Ülések olvasása…",
      replaceConfirm: "Lecseréli a jelenlegi székeket és mondatokat a javaslatokra?",
      failed: "Nem sikerült székeket javasolni",
      consent: "Ez a kliens nem járult hozzá az AI-elemzéshez.",
      sessionsFailed: "Nem sikerült betölteni az üléseket",
      noSessions: "Ennek a kliensnek még nincs ülése.",
    },
    title: "Élményalapú",
    chairTitle: "Sématerápiás szék",
    rescriptTitle: "Képi újraírás",
    addChair: "Szék hozzáadása",
    removeChair: "Eltávolítás",
    text: "Amit ez a mód mond",
    voice: "Hang",
    mode: "Mód",
    generate: "Hangok generálása",
    play: "Lejátszás",
    stop: "Leállítás",
    loop: "Ismétlés",
    amplify: "Erősítés",
    scene: "Felidézett jelenet",
    rescript: "Újraírás",
    generateImages: "Képek generálása",
    before: "Előtte",
    after: "Utána",
    present: "Megmutatás a páciensnek",
    policyDeclined: "A képmodell elutasította ezt a leírást — próbáld szimbolikusabban megfogalmazni.",
    genError: "A generálás sikertelen. Kérlek, próbáld újra.",
    modes: {
      punitive_parent: "Büntető Szülő",
      demanding_parent: "Követelőző Szülő",
      vulnerable_child: "Sérülékeny Gyermek",
      angry_child: "Dühös Gyermek",
      impulsive_child: "Impulzív Gyermek",
      happy_child: "Boldog Gyermek",
      detached_protector: "Elkülönülő Védelmező",
      compliant_surrenderer: "Behódoló",
      healthy_adult: "Egészséges Felnőtt",
      custom: "Egyéni",
    },
    backToLibrary: "Összes technika",
    searchTechniques: "Technikák keresése…",
    noTechniqueMatch: "Nincs a keresésnek megfelelő technika.",
    groups: {
      voice: "Hang",
      image: "Kép",
      combined: "Hang + kép",
    },
    techniques: {
      schema_chair: "Sématerápiás szék",
      spatial_modes: "Térbeli módok",
      empty_chair: "Üres szék",
      parts_dialogue: "Belső részek párbeszéde (IFS)",
      bus_passengers: "Utasok a buszon",
      compassionate_letter: "Együttérző levél",
      needed_words: "A hiányzó szavak",
      defusion_voice: "Defúziós hang",
      loop_tape: "A végtelenített szalag",
      tape_forward: "A szalag lejátszása a végéig",
      urge_surfing: "Sóvárgás-szörfözés",
      couples_cycle: "A kör, visszajátszva",
      brain_cast: "Az agy szereposztása",
      playback_theatre: "Visszajátszó színház",
      tale_story: "Terápiás mese",
      metaphor_induction: "Metafora-indukció",
      sleep_story: "Altató történet",
      miracle_question: "A csodakérdés",
      worry_monster: "Az aggodalom-szörnyecske",
      brave_rehearsal: "Bátorság-próba",
      nightmare_rescript: "Rémálom-újraírás",
      pendulation: "Ingázás",
      imagery_rescript: "Képi újraírás",
      felt_sense: "Zsigeri érzés képe",
      safe_container: "Biztonságos tároló",
      safe_place: "Biztonságos hely",
      metaphor_deck: "Metafora-kártyák",
      distant_screen: "A távolodó vászon",
      compassionate_other: "Együttérző másik",
    },
    techniqueHints: {
      schema_chair: "A sémamódok együtt szólalnak meg — élőben keverhetőek",
      spatial_modes: "Minden mód a tér más pontjáról szól (fejhallgatóval)",
      empty_chair: "Párbeszéd valakivel, aki nincs a szobában",
      parts_dialogue: "Belső részek és a Szelf, felváltva megszólalva",
      bus_passengers: "A gondolatok zajonganak; a kliens tovább vezet",
      compassionate_letter: "A kliens kedves szavai, felolvasva neki",
      needed_words: "A szavak, amikre szüksége lett volna — végre kimondva",
      defusion_voice: "A tapadós gondolat újramondva — lassan, gyorsan, távolról",
      loop_tape: "A kényszergondolat ismételve, míg el nem veszti erejét",
      tape_forward: "A késztetés lejátszva az első pohár után — és a másik befejezés",
      urge_surfing: "A sóvárgás mint hullám: emelkedik, tetőzik, elvonul",
      couples_cycle: "Az üldöző–visszahúzódó tánc, kívülről hallva",
      brain_cast: "Az amigdala és a kéreg elmagyarázza a pánikot, szereplőként",
      playback_theatre: "A kliens pillanata, a hangok által visszajátszva",
      tale_story: "Terápiás mese, fejezetenként felolvasva",
      metaphor_induction: "Lassú, személyre szabott utazás, ericksoni stílusban",
      sleep_story: "A biztonságos helye, elalvás előtti történetbe szőve",
      miracle_question: "A csoda utáni reggel, látva és hallva",
      worry_monster: "Az aggodalom mint barátságos lény, akit egy gyerek legyőzhet",
      brave_rehearsal: "A félelmetes pillanat, támogató hanggal begyakorolva",
      nightmare_rescript: "A rémálom átírva és begyakorolva (IRT)",
      pendulation: "Ingázás az erőforrás és a stresszor között, ütemezve",
      imagery_rescript: "Egy felidézett jelenet és újraírása, képekben",
      felt_sense: "Kép finomítása, míg nem illik a zsigeri érzéshez",
      safe_container: "Egy tároló, ami elég erős, hogy megtartsa — megjelenítve",
      safe_place: "A kliens biztonságos helye, a saját szavaiból megjelenítve",
      metaphor_deck: "Szimbolikus kártyák egy témából — válaszd, ami rezonál",
      distant_screen: "Nézd, ahogy a jelenet távolodik: közel, távol, messze",
      compassionate_other: "Egy eszményi együttérző lény, látva és hallva",
    },
    roles: {
      self: "Én",
      other: "A Másik",
      the_tape: "A szalag",
      the_alternative: "A másik befejezés",
      pursuer: "Az üldöző",
      withdrawer: "A visszahúzódó",
      amygdala: "Amigdala",
      cortex: "Kéreg",
      breath: "A légzés",
      narrator: "Mesélő",
      voice: "Egy hang",
      character: "Szereplő",
      ifs_self: "Szelf",
      manager: "Menedzser",
      firefighter: "Tűzoltó",
      exile: "Száműzött",
      critic: "A Kritikus",
      worry: "Aggodalom",
      fear: "Félelem",
      shame: "Szégyen",
      anger: "Düh",
      custom: "Egyéni",
    },
    chairLabel: "Szék",
    part: "Rész",
    passenger: "Utas",
    addTurn: "Megszólalás hozzáadása",
    addPassenger: "Utas hozzáadása",
    readBy: "Felolvassa",
    letterText: "A levél, a kliens saját szavaival",
    neededText: "A szavak, amiket hallania kellett volna",
    feltSenseDesc: "Írd le a zsigeri érzést",
    refineLabel: "Mitől illene jobban?",
    refineHint: 'pl. „melegebb”, „nehezebb”, „inkább alkonyat, mint éjszaka”',
    refine: "Finomítás",
    attempt: "Próbálkozás",
    containerDesc: "Írd le a tárolót",
    deckTheme: "Téma",
    deckCount: "Kártyák",
    generateDeck: "Pakli generálása",
    card: "Kártya",
    distScene: "A jelenet",
    generateSeries: "Sorozat generálása",
    distSteps: {
      near: "Közel",
      mid: "Távol",
      far: "Messze",
    },
    otherDesc: "Írd le az együttérző lényt",
    otherWords: "Amit mond",
    safePlaceDesc: "Írd le a biztonságos helyet",
    take: "Felvétel",
    partner: "Partner",
    character: "Szereplő",
    addChapter: "Fejezet hozzáadása",
    loopTapeText: "A kényszergondolat, pontosan ahogy jön",
    narrationText: "A narráció",
    inductionText: "Az indukciós szöveg",
    sleepStoryText: "Az altató történet (sződd bele a biztonságos helyét)",
    miracleDesc: "A csoda utáni reggel — mit lát?",
    miracleWords: "Ahogy ő leírja azt a reggelt",
    monsterDesc: "Írd le az aggodalmat lényként",
    monsterWords: "Amit az aggodalom-szörnyecske mond",
    braveDesc: "A félelmetes pillanat, jelenetként",
    braveWords: "A támogató szöveg, az ő oldalán",
    nightmareScene: "A visszatérő rémálom",
    nightmareRescript: "Az átírt változat",
    playNightmare: "Rémálom lejátszása",
    rehearseRescript: "Átirat gyakorlása",
    nightmareLabel: "A rémálom",
    rescriptLabel: "Átírva",
    pendulationStressor: "A nehéz dolog (stresszor)",
    pendulationResource: "Az erőforrás (ahol rendben van)",
    pendulationNarration: "Az ütemező narráció",
    pendulateToStressor: "Pillantás a nehéz dologra",
    pendulateToResource: "Vissza az erőforráshoz",
    spatialHint: "Fejhallgatóval a legjobb — minden hang a tér más pontjáról szól.",
    defusionText: "A tapadós gondolat",
    defusionVariants: {
      plain: "Ahogy elhangzott",
      slow: "Lelassítva",
      fast: "Felgyorsítva",
      far: "Távolról",
    },
  },
  assessments: {
    sendQuestionnaire: "Kérdőív küldése",
    send: "Küldés",
    sending: "Küldés…",
    items: "tétel",
    statusSent: "Elküldve",
    sentAt: "Elküldve",
    completedAt: "Kitöltve",
    score: "Pontszám",
    awaitingResponse: "Várakozás a páciens kitöltésére.",
    definitionsUnavailable: "A kérdőív-definíciók nem tölthetők be.",
    upload: "Feltöltés",
    chooseFile: "Fájl kiválasztása",
    uploading: "Feltöltés…",
    uploaded: "Feltöltések",
    uploadedAt: "Feltöltve",
    noUploads: "Még nincs feltöltés.",
    noUploadsChip: "Még nincs feltöltés",
    filesCount_one: "{{count}} fájl",
    filesCount_other: "{{count}} fájl",
    noticeUploaded: "Feltöltve.",
    noticeSaved: "Mentve.",
    noticeDeleted: "Törölve.",
    noticeParsed: "Feldolgozva.",
    loadFailed: "A tesztek betöltése sikertelen",
    uploadFailed: "A feltöltés sikertelen",
    openEditorFailed: "A szerkesztő megnyitása sikertelen",
    saveFailed: "A mentés sikertelen",
    parseFailed: "A feldolgozás sikertelen",
    parseRefreshFailed: "A feldolgozás sikertelen, és a frissítés is meghiúsult",
    deleteFailed: "A törlés sikertelen",
    deleteTitle: "Teszt törlése",
    deleteConfirm: "Törli: \"{{name}}\"?",
    statusParsed: "Feldolgozva",
    statusParsing: "Feldolgozás",
    statusError: "Hiba",
    statusNotParsed: "Nincs feldolgozva",
    parsing: "Feldolgozás…",
    editParser: "Feldolgozó szerkesztése",
    parserPrompt: "Feldolgozó prompt",
    parserPromptPlaceholder: "Adja meg a feldolgozó promptot…",
    result: "Eredmény",
    noResultYet: "Még nincs eredmény. Kattintson a Futtatás gombra.",
    parseModel: "modell",
    parsedAt: "feldolgozva",
    keysLabel: "kulcsok",
    keysMissing: "hiányzó kulcsok (tp_pk/sk)",
    reviewTemplateNotFound: "Nem sikerült megnyitni ezt a kérdőívet átnézésre — próbáld újra.",
    sendBuiltinGroup: "Beépített kérdőívek",
    sendCustomGroup: "Saját kérdőíveid",
    sendNoTemplates: "Még nincs kész kérdőíved — tölts fel és nézz át egyet fent.",
    channelLabel: "Kézbesítési csatorna",
    sendChannelApp: "App",
    sendChannelEmail: "E-mail",
    sendGateBuiltinAppOnly: "A beépített kérdőívek csak az appban küldhetők.",
    sendGateNoClientAccount: "Előbb hívd meg ezt a klienst az appba.",
    sendGateNoEmail: "Nincs e-mail cím rögzítve ehhez a klienshez.",
    sendGateLoading: "Kliensfiók ellenőrzése…",
    attachOriginal: "Eredeti fájl csatolása",
    channelApp: "App",
    channelEmail: "E-mail",
    statusCompletedManually: "Manuálisan kitöltve",
    completedManuallyNote: "Manuálisan kitöltve — nincs digitális válasz.",
    markCompleted: "Kitöltöttként jelölés",
    markCompletedFailed: "Nem sikerült kitöltöttként jelölni ezt a kérdőívet.",
    noticeMarkedCompleted: "Kitöltöttként megjelölve.",
    cancelSend: "Küldés visszavonása",
    cancelSendTitle: "Visszavonod a kérdőív küldését?",
    cancelSendConfirm: "Visszavonod \"{{name}}\" küldését? A kliens ezután már nem tudja majd kitölteni.",
    cancelSendConfirmLabel: "Küldés visszavonása",
    cancelSendFailed: "Nem sikerült visszavonni ezt a küldést.",
    noticeCancelled: "Küldés visszavonva.",
  },
  qshelf: {
    title: "Saját kérdőíveid",
    hint: "Tölts fel egy PDF, szöveg, Markdown, Excel vagy Word fájlt a saját kérdőíveddel — az Affektra tételekre bontja, amiket átnézhetsz és elküldhetsz.",
    uploadButton: "Kérdőív feltöltése",
    uploading: "Feltöltés…",
    uploadingPct: "Feltöltés… {{pct}}%",
    loading: "Saját kérdőívek betöltése…",
    empty: "Még nincs feltöltött kérdőív.",
    tooLarge: "Ez a fájl nagyobb, mint 7MB — tölts fel egy kisebb fájlt.",
    statusParsing: "Feldolgozás…",
    statusNeedsReview: "Átnézésre vár",
    statusReady: "Kész",
    statusParseFailed: "A feldolgozás sikertelen",
    review: "Átnézés",
    send: "Küldés",
    loadFailed: "A saját kérdőívek betöltése sikertelen.",
    uploadFailed: "A feltöltés sikertelen.",
    parseFailed: "A feldolgozás sikertelen.",
    deleteFailed: "A törlés sikertelen.",
    deleteTitle: "Kérdőív törlése",
    deleteConfirm: "Törli: \"{{name}}\"? Ez nem vonható vissza.",
  },
  qreview: {
    title: "Kérdőív átnézése",
    nameLabel: "Név",
    timeframeLabel: "Időkeret (opcionális)",
    timeframePlaceholder: "pl. Az elmúlt 2 hétben",
    langLabel: "Nyelv",
    langEn: "Angol",
    langHu: "Magyar",
    itemsTitle: "Tételek",
    itemTextPlaceholder: "Tétel szövege",
    addItem: "Tétel hozzáadása",
    moveUp: "Tétel feljebb",
    moveDown: "Tétel lejjebb",
    scaleTitle: "Skála",
    scaleValuePlaceholder: "Érték",
    scaleLabelPlaceholder: "Címke",
    addScaleStep: "Fokozat hozzáadása",
    saving: "Mentés…",
    saveFailed: "A mentés sikertelen.",
    errorNameRequired: "A név megadása kötelező.",
    errorNameTooLong: "A név túl hosszú (max {{max}} karakter).",
    errorTimeframeTooLong: "Az időkeret túl hosszú (max {{max}} karakter).",
    errorItemsRequired: "Legalább egy tétel szükséges.",
    errorItemsTooMany: "Túl sok tétel ({{count}}; max {{max}}).",
    errorItemTextRequired: "A tétel szövege kötelező.",
    errorItemTextTooLong: "A tétel szövege túl hosszú (max {{max}} karakter).",
    errorItemIdDuplicate: "Ennek a tételnek duplikált azonosítója van — töröld és vedd fel újra.",
    errorScaleStepsMin: "A skálának legalább 2 fokozatra van szüksége.",
    errorScaleStepsTooMany: "Túl sok skálafokozat ({{count}}; max {{max}}).",
    errorScaleValueInvalid: "Az értéknek egész számnak kell lennie.",
    errorScaleValueDuplicate: "Minden skálaértéknek egyedinek kell lennie.",
    errorScaleLabelRequired: "A címke megadása kötelező.",
    errorScaleLabelTooLong: "A címke túl hosszú (max {{max}} karakter).",
  },
  toolkit: {
    searchPlaceholder: "Technikák keresése…",
    filterSource: "Forrás",
    filterModality: "Bemenet típusa",
    filterAll: "Mind",
    filterMine: "Sajátjaim",
    filterLibrary: "Könyvtár",
    filterAnyInput: "Bármilyen bemenet",
    filterTranscript: "Leirat",
    filterAudio: "Hang",
    filterVision: "Kép",
    badgeMine: "Saját",
    badgeLibrary: "Könyvtár",
    badgeWip: "Készülőben",
    modality: {
      transcript: "Ülésen fut",
      audio: "Hangeszköz",
      vision: "Képeszköz",
      both: "Hang + kép eszköz",
    },
    noMatch: "Nincs találat.",
    loading: "Technikák betöltése…",
    retry: "Újra",
    back: "Vissza az eszköztárhoz",
    run: "Futtatás",
    running: "Fut…",
    runTimeout: "Időtúllépés az eredményre várva.",
    sessionsLabel: "Ülések",
    runCount: "Futtatás · {{count}} ülés",
    noSummaryFor: "Ezeknek az üléseknek még nincs összefoglalója: {{dates}}. Előbb készíts összefoglalót.",
    selectClientFirst: "Válassz klienst a technika használatához.",
    noSessions: "Ennek a kliensnek még nincs mentett ülése.",
    copy: "Másolás",
    copied: "Vágólapra másolva",
    seeExample: "Példa megtekintése",
    comingSoon: "Ez a technika még készülőben van — a lenti példa mutatja, mit fog előállítani.",
  },
  progressNotes: {
    generate: "Jegyzet generálása",
    generating: "Generálás…",
    language: "Nyelv",
    statusDraft: "Vázlat",
    statusSigned: "Aláírva",
    draftBanner: "MI-vázlat — aláírás előtt ellenőrizze.",
    save: "Mentés",
    sign: "Aláírás",
    signConfirm: "Az aláírás véglegesíti a jegyzetet. Biztosan folytatja?",
    signedAt: "Aláírva",
    regenerate: "Újragenerálás",
    regenerateConfirm: "Az újragenerálás törli a szerkesztéseket. Biztosan folytatja?",
    delete: "Törlés",
    deleteDraftConfirm: "Ez törli a jegyzet vázlatát. Biztosan folytatja?",
    deleteSignedConfirm: "Ez egy aláírt klinikai jegyzetet töröl. Biztosan folytatja?",
    copy: "Másolás",
    copied: "Másolva",
  },
  publicFill: {
    loading: "Kérdőív betöltése…",
    submit: "Válaszok elküldése",
    submitting: "Küldés…",
    requiredField: "Kérjük, válaszoljon erre a kérdésre.",
    requiredAll: "Kérjük, küldés előtt válaszoljon minden kérdésre.",
    thanksTitle: "Köszönjük",
    thanksBody: "Válaszait rögzítettük. Ezt az oldalt bezárhatja.",
    errorNotFoundTitle: "A hivatkozás nem található",
    errorNotFoundBody: "Ez a kérdőív-hivatkozás érvénytelen. Kérjen újat a terapeutájától.",
    errorExpiredTitle: "A hivatkozás lejárt",
    errorExpiredBody: "Ez a kérdőív-hivatkozás lejárt. Kérje meg terapeutáját, hogy küldjön újat.",
    errorUsedTitle: "Már elküldve",
    errorUsedBody: "Ezt a kérdőívet már kitöltötték. Nincs több teendő.",
    errorGenericTitle: "Hiba történt",
    errorGenericBody: "Nem sikerült betölteni a kérdőívet. Próbálja újra, vagy kérjen új hivatkozást a terapeutájától.",
  },
};
export default hu;
